import * as React from "react"
const SvgCloudCheck = props => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="currentColor"
    viewBox="0 0 24 24"
    {...props}
  >
    <path d="m10.325 14.982-1.4-1.4a.96.96 0 0 0-.7-.3q-.4 0-.7.3t-.3.713.3.712l2.125 2.15q.3.3.7.3t.7-.3l4.225-4.225q.3-.3.3-.725t-.3-.725-.725-.3c-.425 0-.525.1-.725.3zM6.5 20.857q-2.275 0-3.888-1.575T1 15.432q0-1.95 1.175-3.475c1.175-1.525 1.808-1.667 3.075-1.95q.625-2.3 2.5-3.725T12 4.857q2.925 0 4.962 2.038Q19.001 8.932 19 11.857q1.725.201 2.863 1.488A4.4 4.4 0 0 1 23 16.357q0 1.875-1.313 3.188c-1.313 1.313-1.937 1.312-3.187 1.312zm0-2h12q1.05 0 1.775-.725T21 16.357c0-1.05-.242-1.291-.725-1.775q-.725-.725-1.775-.725H17v-2q0-2.075-1.463-3.537Q14.075 6.857 12 6.857c-2.075 0-2.563.488-3.537 1.463Q7 9.782 7 11.857h-.5q-1.45 0-2.475 1.025A3.37 3.37 0 0 0 3 15.357q0 1.45 1.025 2.475A3.37 3.37 0 0 0 6.5 18.857" />
  </svg>
)
export default SvgCloudCheck
